<template>
    <div class="admindashboard">

        <el-card class="box-card">
            <template #header>
                <div class="logo-header">
                    <span class="ta-left">Deutsches Rotes Kreuz<br>Hurricane Festival 2026<br>Sanitäts- und Rettungsdienst</span>
                    <div>
                        <img src="../../assets/logo-drk.svg" class="logo-image"/>
                        <br>
                        <el-button type="danger" @click="logout">Abmelden</el-button>
                        <br>
                        <router-link to="/unitdashboard">
                            <el-button type="primary" style="margin-top: 5px;">Zurück zum Dashboard</el-button>
                        </router-link>
                        <br>
                        <password/>
                    </div>
                </div>
                <div class="nav-buttons">
                    <router-link to="/admin/users">
                        <el-button type="primary">Benutzerverwaltung</el-button>
                    </router-link>
                    <router-link to="/admin/helfer">
                        <el-button type="primary">Helfer suchen</el-button>
                    </router-link>
                    <router-link to="/verpflegung">
                        <el-button type="primary">Verpflegung</el-button>
                    </router-link>
                </div>
            </template>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-card>
                        <template #header>
                            <h3>Helfer Übersicht ({{ helperTotal }})</h3>
                        </template>
                        <el-table :data="tableUnits" stripe style="width: 100%" class="unittable">
                            <el-table-column prop="unit" label="Einheit"/>
                            <el-table-column prop="count" label="Anzahl"/>
                        </el-table>
                    </el-card>
                    <el-card style="margin-top: 20px;">
                        <template #header>
                            <h3>CSV Export</h3>
                        </template>
                        <p v-if="exportCount > 0">
                            <strong>{{ exportCount }}</strong> neue Helfer seit dem letzten Export.
                        </p>
                        <p v-else style="color: #909399;">
                            Keine neuen Helfer zum Exportieren.
                        </p>
                        <el-button
                            type="success"
                            @click="exportCsv"
                            :loading="exporting"
                            :disabled="exportCount === 0"
                            style="margin-top: 10px;"
                        >
                            <el-icon style="margin-right: 5px;"><download /></el-icon>
                            {{ exportCount }} Helfer exportieren
                        </el-button>
                        <div style="margin-top: 10px; display: flex; align-items: center; gap: 8px;">
                            <el-switch v-model="dryRun" />
                            <span>Dry-Run (Helfer nicht als exportiert markieren)</span>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card>
                        <template #header>
                            <h3>CSV Import</h3>
                        </template>
                        <el-upload
                            ref="upload"
                            :auto-upload="false"
                            :on-change="handleFileChange"
                            :limit="1"
                            accept=".csv"
                            drag
                        >
                            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                            <div class="el-upload__text">
                                CSV-Datei hierher ziehen oder <em>klicken</em>
                            </div>
                            <template #tip>
                                <div class="el-upload__tip">
                                    <strong>Felder:</strong> firstname, name, birthname, birthdate (dd.mm.yyyy), birthtown, birthcountry, email, essen, fachqualifikation, fuehrung_rd, fuehrung_kats, facharzt, notarztqualifikation<br>
                                    <a href="/helfer-vorlage.xlsx" download>Vorlage herunterladen</a>
                                </div>
                            </template>
                        </el-upload>
                        <div v-if="csvPreview.length > 0" style="margin-top: 15px;">
                            <h4>Vorschau ({{ csvPreview.length }} Einträge)</h4>
                            <el-table :data="csvPreview.slice(0, 5)" stripe style="width: 100%" max-height="200">
                                <el-table-column prop="firstname" label="Vorname" width="100"/>
                                <el-table-column prop="name" label="Name" width="100"/>
                                <el-table-column prop="unit" label="Einheit" width="150"/>
                                <el-table-column prop="email" label="E-Mail"/>
                            </el-table>
                            <p v-if="csvPreview.length > 5" style="color: #909399; font-size: 12px;">
                                ... und {{ csvPreview.length - 5 }} weitere Einträge
                            </p>
                            <el-button type="success" @click="importCsv" style="margin-top: 10px;" :loading="importing">
                                {{ csvPreview.length }} Helfer importieren
                            </el-button>
                            <el-button @click="clearCsv" style="margin-top: 10px;">
                                Abbrechen
                            </el-button>
                        </div>
                    </el-card>
                    <el-card style="margin-top: 20px;">
                        <template #header>
                            <div class="card-header">
                                <h3>Car Pass Übersicht</h3>
                                <el-button type="success" @click="exportCarpassCsv" :disabled="carpassList.length === 0">
                                    Liste exportieren ({{ carpassList.length }})
                                </el-button>
                            </div>
                        </template>
                        <el-table :data="carpassByUnit" stripe style="width: 100%" class="unittable">
                            <el-table-column prop="unit" label="Einheit"/>
                            <el-table-column prop="count" label="Anzahl Car Pässe" width="180"/>
                        </el-table>
                    </el-card>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    import Axios from "axios";
    import Password from "@/components/password.vue";
    import { UploadFilled, Download } from '@element-plus/icons-vue';
    import { ElNotification } from 'element-plus';
    import ExcelJS from 'exceljs';

    export default {
        name: "AdminDashboard",
        components: { Password, UploadFilled, Download },
        computed: {
            helperTotal() {
                return this.tableUnits.reduce((sum, u) => sum + (Number(u.count) || 0), 0);
            }
        },
        data() {
            return {
                tableUnits: [],
                csvPreview: [],
                importing: false,
                exporting: false,
                exportCount: 0,
                dryRun: false,
                carpassByUnit: [],
                carpassList: [],
            }
        },
        methods: {
            logout() {
                this.$store.dispatch('logout');
                this.$router.push('/');
            },
            loadUnit() {
                this.tableUnits = [];
                Axios.get(`${process.env.VUE_APP_API_URL}/api/admin/personalOverview/`)
                    .then(response => {
                        response.data.data.forEach(item => {
                            this.tableUnits.push({
                                unit: item.unit,
                                count: item.count,
                            });
                        })
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            loadData() {
                this.loadUnit();
                this.loadExportCount();
                this.loadCarpassOverview();
            },
            async loadCarpassOverview() {
                try {
                    const response = await Axios.get(`${process.env.VUE_APP_API_URL}/api/admin/carpass-overview`);
                    this.carpassByUnit = response.data.data.byUnit || [];
                    this.carpassList = response.data.data.list || [];
                } catch (error) {
                    console.log('carpass overview:', error);
                }
            },
            mapCarpassTyp(typ) {
                switch (String(typ)) {
                    case '0': return 'PKW';
                    case '1': return 'MTW';
                    case '2': return 'KTW/RTW';
                    case '3': return 'GW';
                    case '4': return 'LKW';
                    case '5': return 'Sonstiges';
                    default: return '';
                }
            },
            exportCarpassCsv() {
                if (this.carpassList.length === 0) return;
                const headers = ['Vorname', 'Nachname', 'Kennzeichen', 'Fahrzeugtyp', 'Einheit'];
                const escape = (v) => {
                    const s = (v ?? '').toString();
                    return s.includes(';') || s.includes('"') || s.includes('\n')
                        ? '"' + s.replace(/"/g, '""') + '"' : s;
                };
                const lines = [headers.join(';')];
                this.carpassList.forEach(r => {
                    lines.push([r.firstname, r.name, r.kennzeichen, this.mapCarpassTyp(r.typ), r.unit].map(escape).join(';'));
                });
                const blob = new Blob(['﻿' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                const date = new Date().toISOString().slice(0, 10);
                link.href = url;
                link.download = `carpass-${date}.csv`;
                link.click();
                URL.revokeObjectURL(url);
            },
            async loadExportCount() {
                try {
                    const response = await Axios.get(`${process.env.VUE_APP_API_URL}/api/admin/export-count`);
                    this.exportCount = response.data.data.count;
                } catch (error) {
                    console.log(error);
                }
            },
            formatBirthdate(value) {
                if (!value) return '';
                const s = String(value).slice(0, 10);
                const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
                return m ? `${m[3]}.${m[2]}.${m[1]}` : s;
            },
            async exportCsv() {
                this.exporting = true;
                try {
                    const response = await Axios.get(`${process.env.VUE_APP_API_URL}/api/admin/export-csv`, {
                        params: { dry_run: this.dryRun ? 1 : 0 }
                    });
                    const csvData = response.data.data.csv_data;

                    if (!csvData || csvData.length === 0) {
                        ElNotification({ title: 'Info', message: 'Keine neuen Helfer zum Exportieren', type: 'info' });
                        return;
                    }

                    // Spaltenreihenfolge gem\u00E4\u00DF Importvorlage_Personaldatenbank Festivalmanager.xlsx
                    const headers = [
                        'VORNAME',
                        'ABWEICHENDER VORNAME IM AUSWEISDOKUMENT',
                        'NACHNAME',
                        'NACHNAME BEI GEBURT',
                        'GEBURTSTAG',
                        'GEBURTSORT',
                        'GEBURTSLAND',
                        'EMAIL',
                        'SPRACHE',
                        'ERN\u00C4HRUNGSWEISE CATERING',
                        'TSHIRT GR\u00D6SSE',
                        'NOTIZ'
                    ];

                    const workbook = new ExcelJS.Workbook();
                    const sheet = workbook.addWorksheet('Personaldatenbank');
                    sheet.addRow(headers);
                    sheet.getRow(1).font = { bold: true };

                    csvData.forEach(row => {
                        sheet.addRow([
                            row.vorname || '',
                            '',
                            row.nachname || '',
                            row.geburtsname || '',
                            this.formatBirthdate(row.geburtsdatum),
                            row.geburtsort || '',
                            row.geburtsland || '',
                            row.email || '',
                            '',
                            '',
                            '',
                            row.einheit || ''
                        ]);
                    });

                    // Spaltenbreiten orientieren sich an der Vorlage
                    const widths = [12, 48, 12, 24, 13, 13, 19, 27, 12, 31, 16, 50];
                    widths.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });

                    const buffer = await workbook.xlsx.writeBuffer();
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    const date = new Date().toISOString().slice(0, 10);
                    link.href = url;
                    link.download = `helfer-export-${date}.xlsx`;
                    link.click();
                    URL.revokeObjectURL(url);

                    ElNotification({
                        title: this.dryRun ? 'Dry-Run erfolgreich' : 'Export erfolgreich',
                        message: `${csvData.length} Helfer exportiert${this.dryRun ? ' (Dry-Run – nicht als exportiert markiert)' : ''}`,
                        type: 'success'
                    });
                    this.loadExportCount();
                } catch (error) {
                    ElNotification({
                        title: 'Fehler',
                        message: error.response?.data?.message || 'Export fehlgeschlagen',
                        type: 'error'
                    });
                } finally {
                    this.exporting = false;
                }
            },
            handleFileChange(file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const text = e.target.result;
                    this.parseCsv(text);
                };
                reader.readAsText(file.raw);
            },
            parseCsv(text) {
                const headerMap = {
                    'vorname': 'firstname',
                    'nachname': 'name',
                    'geburtsname': 'birthname',
                    'geburtsdatum': 'birthdate',
                    'geburtsort': 'birthtown',
                    'geburtsland': 'birthcountry',
                    'e-mail': 'email',
                    'essen': 'essen',
                    'fachqualifikation': 'fachqualifikation',
                    'fuehrung_rd': 'fuehrung_rd',
                    'fuehrung_kats': 'fuehrung_kats',
                    'facharzt': 'facharzt',
                    'notarztqualifikation': 'notarztqualifikation',
                    'do tagschicht': 'do_tag',
                    'do nachtschicht': 'do_nacht',
                    'do sonstig': 'do_sonstig',
                    'fr tagschicht': 'fr_tag',
                    'fr nachtschicht': 'fr_nacht',
                    'fr konzertschicht': 'fr_konzert',
                    'fr sonstig': 'fr_sonstig',
                    'sa tagschicht': 'sa_tag',
                    'sa nachtschicht': 'sa_nacht',
                    'sa konzertschicht': 'sa_konzert',
                    'sa sonstig': 'sa_sonstig',
                    'so tagschicht': 'so_tag',
                    'so nachtschicht': 'so_nacht',
                    'so konzertschicht': 'so_konzert',
                    'so sonstig': 'so_sonstig',
                    'mo tagschicht': 'mo_tag',
                    'mo sonstig': 'mo_sonstig',
                };

                const lines = text.split('\n').filter(line => line.trim());
                if (lines.length < 2) {
                    ElNotification({
                        title: 'Fehler',
                        message: 'CSV-Datei ist leer oder enthält keine Daten',
                        type: 'error'
                    });
                    return;
                }

                const rawHeaders = lines[0].split(';').map(h => h.trim().replace(/"/g, ''));
                const headers = rawHeaders.map(h => headerMap[h.toLowerCase()] || h);
                const data = [];

                for (let i = 1; i < lines.length; i++) {
                    const values = lines[i].split(';').map(v => v.trim().replace(/"/g, ''));
                    const row = {};
                    headers.forEach((header, index) => {
                        row[header] = values[index] || '';
                    });
                    if (row.name || row.firstname) {
                        data.push(row);
                    }
                }

                this.csvPreview = data;
                ElNotification({
                    title: 'CSV geladen',
                    message: `${data.length} Einträge gefunden`,
                    type: 'success'
                });
            },
            clearCsv() {
                this.csvPreview = [];
                this.$refs.upload.clearFiles();
            },
            convertDate(dateStr) {
                if (!dateStr) return dateStr;
                const parts = dateStr.split('.');
                if (parts.length !== 3) return dateStr;
                let [day, month, year] = parts;
                day = day.padStart(2, '0');
                month = month.padStart(2, '0');
                if (year.length === 2) {
                    year = parseInt(year) > 50 ? '19' + year : '20' + year;
                }
                return `${year}-${month}-${day}`;
            },
            async importCsv() {
                if (this.csvPreview.length === 0) return;

                this.importing = true;
                try {
                    const eatingMap = {
                        'keine einschraenkung': 'normal', 'keine einschränkung': 'normal', 'normal': 'normal',
                        'glutenfrei': 'glutenfrei',
                        'vegan': 'vegan',
                        'vegan / glutenfrei': 'vegu', 'vegan/glutenfrei': 'vegu',
                    };
                    const professionalMap = {
                        'erste hilfe': 'eh', 'san': 'san',
                        'rettungshelfer': 'rh', 'rettungssanitaeter': 'rs', 'rettungssanitäter': 'rs',
                        'rettungsassistent': 'ra', 'notfallsanitaeter': 'nfs', 'notfallsanitäter': 'nfs',
                        'arzt': 'arzt',
                    };
                    const leadershipRDMap = {
                        'gruppenfuehrer': 'gf', 'gruppenführer': 'gf',
                        'zugfuehrer': 'zf', 'zugführer': 'zf',
                        'orgl': 'orgl',
                    };
                    const leadershipKatSMap = {
                        'gruppenfuehrer': 'gf', 'gruppenführer': 'gf',
                        'zugfuehrer': 'zf', 'zugführer': 'zf',
                        'verbandfuehrer': 'vf', 'verbandsfuehrer': 'vf',
                        'verbandführer': 'vf', 'verbandsführer': 'vf',
                    };
                    const mapLeadership = (val, map) => {
                        if (!val) return null;
                        const lower = val.toLowerCase();
                        if (lower === 'keine') return null;
                        return map[lower] || val;
                    };
                    const jaToBool = (val) => (val || '').toLowerCase() === 'ja' ? 1 : 0;
                    const calculateMealtimes = (row) => {
                        const meals = { dobr: false, dolu: false, dodi: false, dode: false, frbr: false, frlu: false, frdi: false, frde: false, sabr: false, salu: false, sadi: false, sade: false, sobr: false, solu: false, sodi: false, sode: false, mobr: false, molu: false, modi: false, mode: false };
                        if (row.doda) { meals.dobr = true; meals.dolu = true; meals.dodi = true; }
                        if (row.frda) { meals.frbr = true; meals.frlu = true; meals.frdi = true; }
                        if (row.sada) { meals.sabr = true; meals.salu = true; meals.sadi = true; }
                        if (row.soda) { meals.sobr = true; meals.solu = true; meals.sodi = true; }
                        if (row.moda) { meals.mobr = true; meals.molu = true; meals.modi = true; }
                        if (row.doni) { meals.dodi = true; meals.dode = true; meals.frbr = true; }
                        if (row.frni) { meals.frdi = true; meals.frde = true; meals.sabr = true; }
                        if (row.sani) { meals.sadi = true; meals.sade = true; meals.sobr = true; }
                        if (row.soni) { meals.sodi = true; meals.sode = true; meals.mobr = true; }
                        if (row.frco) { meals.frlu = true; meals.frdi = true; meals.frde = true; }
                        if (row.saco) { meals.salu = true; meals.sadi = true; meals.sade = true; }
                        if (row.soco) { meals.solu = true; meals.sodi = true; meals.sode = true; }
                        return meals;
                    };
                    const csvData = this.csvPreview.map(row => {
                        const mapped = {
                            ...row,
                            birthdate: this.convertDate(row.birthdate),
                            eating: eatingMap[(row.essen || '').toLowerCase()] || row.essen || '',
                            professionalValue: professionalMap[(row.fachqualifikation || '').toLowerCase()] || row.fachqualifikation || '',
                            leadershipRD: mapLeadership(row.fuehrung_rd, leadershipRDMap),
                            leadershipKatS: mapLeadership(row.fuehrung_kats, leadershipKatSMap),
                            facharzt: jaToBool(row.facharzt),
                            notarztQualifikation: jaToBool(row.notarztqualifikation),
                            doda: jaToBool(row.do_tag),
                            doni: jaToBool(row.do_nacht),
                            dokt: row.do_sonstig ? (jaToBool(row.do_sonstig) ? 1 : 2) : 2,
                            frda: jaToBool(row.fr_tag),
                            frni: jaToBool(row.fr_nacht),
                            frco: jaToBool(row.fr_konzert),
                            frkt: row.fr_sonstig ? (jaToBool(row.fr_sonstig) ? 1 : 2) : 2,
                            sada: jaToBool(row.sa_tag),
                            sani: jaToBool(row.sa_nacht),
                            saco: jaToBool(row.sa_konzert),
                            sakt: row.sa_sonstig ? (jaToBool(row.sa_sonstig) ? 1 : 2) : 2,
                            soda: jaToBool(row.so_tag),
                            soni: jaToBool(row.so_nacht),
                            soco: jaToBool(row.so_konzert),
                            sokt: row.so_sonstig ? (jaToBool(row.so_sonstig) ? 1 : 2) : 2,
                            moda: jaToBool(row.mo_tag),
                            mokt: row.mo_sonstig ? (jaToBool(row.mo_sonstig) ? 1 : 2) : 2,
                        };
                        return { ...mapped, ...calculateMealtimes(mapped) };
                    });
                    const response = await Axios.post(`${process.env.VUE_APP_API_URL}/api/import-csv`, {
                        csv_data: csvData
                    });

                    ElNotification({
                        title: 'Import erfolgreich',
                        message: response.data.message,
                        type: 'success'
                    });

                    if (response.data.data.errors && response.data.data.errors.length > 0) {
                        ElNotification({
                            title: 'Warnungen',
                            message: response.data.data.errors.join(', '),
                            type: 'warning',
                            duration: 10000
                        });
                    }

                    this.clearCsv();
                    this.loadUnit();
                } catch (error) {
                    ElNotification({
                        title: 'Fehler',
                        message: error.response?.data?.message || 'Import fehlgeschlagen',
                        type: 'error'
                    });
                } finally {
                    this.importing = false;
                }
            }
        },

        async created() {
            if (!this.$store.getters.isLoggedIn) {
                this.$router.push('/');
                return;
            }
            if (this.$store.getters.getRole !== 99) {
                this.$router.push('/unitdashboard');
                return;
            }
            this.loadData();
        },
    }
</script>

<style scoped>

.admindashboard {
    display: flex;
    align-items: center;
    justify-content: center;
}

.box-card {
    max-width: 1100px;
    flex: auto;
}

.unittable {
    width: 400px !important;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo-image {
    width: 200px;
    display: flex;
}

.logo-header {
    justify-content: space-between;
    display: flex;
}

.ta-left {
    text-align: left;
}

.nav-buttons {
    margin-top: 10px;
}

</style>
